module.exports = __webpack_public_path__ + "img/productions_30.57da1e01.png";